import { render, staticRenderFns } from "./Cooperation-management.pug?vue&type=template&id=41a19a5f&lang=pug&"
import script from "./Cooperation-management.ts?vue&type=script&lang=ts&"
export * from "./Cooperation-management.ts?vue&type=script&lang=ts&"
import style0 from "./Cooperation-management.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports